module.exports = __webpack_public_path__ + "img/2024_MRC_Symposium_SG.af7dd9ac.jpg";